import React from 'react'
import Button from '../Button'

const Modal = ({ message, onClose }) => {
  if (!message) return null

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm mx-auto">
        <h3 className="text-lg font-bold mb-4 text-gray-800">
          Flow Simulation Result
        </h3>
        <p className="whitespace-pre-wrap text-gray-700 mb-6">
          {message}
        </p>
        <div className="flex justify-end">
          <Button onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Modal 